import { apiFetch } from "./api";

export interface Company {
  id: string;
  client_id: string;
  cnpj: string;
  name: string;
  social_reason: string;
  erp_code: string;
}

export type ListCompanyParams = {
  cnpj?: string;
  name?: string;
  socialReason?: string;
  erpCode?: string;
  clientId?: string;
  offset: number;
  limit: number;
}

export type CompanyWithPages = {
  total: number,
  companies: Company[]
}

export function getCompanies(data: ListCompanyParams) {
  const params = new URLSearchParams();

  params.set('offset', String(data.offset));
  params.set('limit', String(data.limit));
  if (data.clientId)
    params.set('client_id', String(data.clientId));
  if (data.cnpj)
    params.set('cnpj', String(data.cnpj));
  if (data.erpCode)
    params.set('erp_code', String(data.erpCode));
  if (data.name)
    params.set('name', String(data.name));
  if (data.socialReason)
    params.set('social_reason', String(data.socialReason));

  const paramString = params.toString();
  return apiFetch<CompanyWithPages>(`/api/companies${paramString ? "?" + paramString : ""}`);
}

export function getCompany(identifier: string) {
  return apiFetch<Company>(`/api/companies/${identifier}`);
}

export function createCompany(data: Company) {
  return apiFetch<Company>("/api/companies", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function updateCompany(id: string, data: Partial<Company>) {
  return apiFetch<Company>(`/api/companies/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export function deleteCompany(id: string) {
  return apiFetch<void>(`/api/companies/${id}`, {
    method: "DELETE",
  });
}